export const ru = {
    'performance-recommendation-text':
        'Для сохранения группы заполните условия показов вручную',
    'tgo-and-performance-recommendation-text':
        'Для сохранения группы включите автотаргетинг или заполните условия показов вручную',
    'tgo-recommendation-text':
        'Для сохранения группы включите автотаргетинг или заполните условия показов вручную'
};
